const Headline: React.FC<{ text: string }> = ({ text }) => {
  return <div className="text-lg font-bold text-blue">{text}</div>
}

export default Headline
